import { Component, OnInit, Input, inject } from '@angular/core';
import { Buyer } from '../../../../dto';
import { BaseComponent } from '../../../../core';
import { GaService, BuyerService } from '../../../../services';

@Component({
  selector: 'app-my-membership-status-navigation',
  templateUrl: './my-membership-status-navigation.component.html',
  styleUrls: ['./my-membership-status-navigation.component.scss'],
  standalone: false,
})
export class MyMembershipStatusNavigationComponent extends BaseComponent implements OnInit {
  private buyerService = inject(BuyerService);

  @Input() currentPage: string;
  buyer: Buyer;

  ngOnInit() {
    this.buyerService.getBuyer().subscribe((buyer) => {
      this.buyer = buyer;
    });
  }

}
